export class WageBase {
  id: number;
  user_id: number;
  base: number;
  fee_percent: number;
  expense_percent: number;
  year: number;
  is_deleted: boolean = false;
  created_at: any;
  updated_at: any;
  created_by: any;
  updated_by: any;
  opener_percent: number;
  owner_percent: number;
  add_to_base: boolean = false;
  include_base_in_factor: boolean = false;
  payroll_expense_percent: number;
  payroll_expense_only_on_factor: boolean = false;
  effective_date: any;
  effective_date_struct: any;
}
